import React from 'react'
import { FcAssistant } from 'react-icons/fc'
import { GiCalendar, GiReceiveMoney } from 'react-icons/gi'
import { Button } from '../../components/ui/Button'

function WhatIsBmgMed({onGoToRegister}) {
    return (
        <section id="WhatIsBmgMed" className="bg-white py-16 px-6 max-w-7xl mx-auto text-center">
            <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
                O que é o Bmg Med
            </span>

            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 max-w-xl mx-auto leading-relaxed mb-4">
                O que é o Bmg Med?
            </h2>

            <p className="text-gray-600 max-w-xl mx-auto mb-12 leading-relaxed">
                O Bmg Med é um serviço de assistência à saúde que oferece proteção para quem você ama. Além de telemedicina grátis e ilimitada, conte com acesso a consultas médicas presenciais e exames a preços populares.
            </p>
            <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
                Vantagens
            </span>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-12 text-left">
                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <FcAssistant className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Telemedicina grátis</h3>
                    <p className="text-gray-600 text-sm">
                        Tenha acesso ilimitado a médicos on-line 24h, sempre que precisar, de onde você estiver.
                    </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <GiReceiveMoney className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Consultas por R$ 50</h3>
                    <p className="text-gray-600 text-sm">
                        Agende consultas médicas presenciais na rede credenciada com valor fixo de R$ 50 e exames com descontos, parcelados em até 12x.
                    </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <GiCalendar className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Desconto em farmácia</h3>
                    <p className="text-gray-600 text-sm">
                        A partir de 15% de desconto em remédios em mais de 6 mil farmácias pelo Brasil.
                    </p>
                </div>
            </div>

            <Button onClick={onGoToRegister} variant="outline">
                Contratar agora
            </Button>
        </section>
    )
}

export default WhatIsBmgMed